import {AgentSessionsTokenProvider} from '@github-ui/copilot-auth-token/agent-sessions-token'
import {makeCAPIRequest, type CAPIRequestOptions} from '@github-ui/copilot-chat/utils/copilot-chat-helpers'
import {getEnv} from '@github-ui/client-env'

const DEFAULT_API_URL = 'https://api.githubcopilot.com'

interface FetchWithAuthOptions {
  path: string
  apiURL?: string | null
  method?: 'GET' | 'POST' | 'DELETE' | 'PATCH'
  streamingResponse?: boolean
  basePath?: string
  body?: object
}

export class FetchCAPI401Error extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'FetchCAPI401Error'
  }
}

export async function fetchCAPI({
  path,
  apiURL,
  method = 'GET',
  streamingResponse = false,
  body,
}: FetchWithAuthOptions): Promise<Response> {
  const tokenProvider = new AgentSessionsTokenProvider()
  const token = await tokenProvider.getAuthToken()

  if (!token) {
    throw new Error('No token available')
  }

  const effectiveApiURL = apiURL ?? DEFAULT_API_URL
  const requestOptions: CAPIRequestOptions = {
    authToken: token,
    basePath: getEnv().copilotApiOverrideUrl ?? effectiveApiURL,
    method,
    path,
    streamingResponse,
    body,
  }
  const response = await makeCAPIRequest(requestOptions)
  if (!response.ok) {
    if (response.status === 401) {
      throw new FetchCAPI401Error('Unauthorized access - token may be invalid or expired')
    }
    throw new Error('Failed to fetch agent sessions')
  }
  return response
}
